(function florameDeliverySyncBootstrap() {
  const config = Object.assign(
    {
      enabled: true,
      deliveryVariantId: 54260855701827,
      deliveryProductHandle: 'consegna',
      deliveryTitle: 'Consegna',
      thresholdCents: 3000,
      apiBase: '',
      pricingCacheMs: 900000,
      cartReadCacheMs: 500,
      debug: false,
      iosRefreshPasses: [0, 20, 800, 1800, 3200],
      defaultRefreshPasses: [0, 450, 1200],
      excludedProductHandles: ['test1', 'test-florame-local'],
      upsellGuardUrl: '',
    },
    window.florameDeliveryConfig || {}
  );

  if (!config.enabled) return;

  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    (window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/\/cart(?:\/)?$/, '/') : '/');

  const SESSION_FLAG_KEY = 'florameDeliveryNeedsSync';
  const PRICING_SESSION_CACHE_KEY = 'florameDeliveryPricingCacheV2';
  const INTERNAL_PROPERTY_KEY = '_florame_delivery_auto';
  const FREE_SHIPPING_TRUCK_SVG = `
    <svg class="florame-free-shipping-alert__truck" fill="currentColor" viewBox="0 0 512 512" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path d="M476.158,286.938l-13.259-53.035c3.625-.77,6.345-3.986,6.345-7.839v-8.551c0-18.566-15.105-33.67-33.67-33.67h-60.392v-17.637c0-9.136-7.432-16.568-16.568-16.568H246.32l68.24-27.296c4.111-1.644,6.11-6.31,4.466-10.421-1.644-4.11-6.307-6.111-10.421-4.466l-55.874,22.349c17.026-10.924,33.871-22.947,40.284-31.355,12.485-16.369,9.323-39.843-7.046-52.328-16.369-12.486-39.843-9.323-52.328,7.046-9.122,11.962-21.158,45.573-28.948,69.258-7.79-23.683-19.826-57.296-28.948-69.258-12.484-16.369-35.959-19.53-52.328-7.046-16.369,12.484-19.53,35.958-7.046,52.328,6.413,8.409,23.257,20.431,40.284,31.355l-55.874-22.349c-4.113-1.647-8.777,.355-10.421,4.466-1.645,4.111,.355,8.777,4.466,10.421l68.24,27.296H50.772c-9.136,0-16.568,7.432-16.568,16.568v145.37c0,4.427,3.589,8.017,8.017,8.017,4.427,0,8.017-3.589,8.017-8.017v-145.37c0-.295,.239-.534,.534-.534h307.841c.295,0,.534,.239,.534,.534v145.372c0,4.427,3.589,8.017,8.017,8.017,4.427,0,8.017-3.589,8.017-8.017v-9.088h94.566c.009,0,.016,.002,.025,.002s.017-.001,.026-.001c11.636,.009,21.516,7.647,24.908,18.171h-24.928c-4.427,0-8.017,3.589-8.017,8.017v17.102c0,13.851,11.268,25.119,25.119,25.119h9.086v35.273h-20.962c-6.886-19.882-25.787-34.205-47.982-34.205s-41.097,14.322-47.982,34.205h-3.86V345.78c0-4.427-3.589-8.017-8.017-8.017-4.427,0-8.017,3.589-8.017,8.017v60.392H192.817c-6.886-19.882-25.787-34.205-47.982-34.205s-41.097,14.322-47.982,34.205H50.772c-.295,0-.534-.239-.534-.534v-17.637h34.739c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017H8.017C3.59,371.967,0,375.556,0,379.984s3.589,8.017,8.017,8.017h26.188v17.637c0,9.136,7.432,16.568,16.568,16.568h43.304c-.002,.178-.014,.355-.014,.534,0,27.995,22.777,50.772,50.772,50.772s50.772-22.777,50.772-50.772c0-.18-.012-.356-.014-.534h180.67c-.002,.178-.014,.355-.014,.534,0,27.995,22.777,50.772,50.772,50.772,27.995,0,50.772-22.777,50.772-50.772,0-.18-.012-.356-.014-.534h26.203c4.427,0,8.017-3.589,8.017-8.017v-85.511c0-21.116-15.577-38.658-35.842-41.741ZM172.9,121.059c-31.623-19.651-41.003-28.692-43.78-32.334-7.123-9.339-5.319-22.732,4.021-29.855,3.85-2.936,8.388-4.355,12.893-4.355,6.422,0,12.776,2.886,16.963,8.376,7.755,10.168,19.9,44.391,27.918,69.052-5.411-3.186-11.631-6.915-18.015-10.884ZM218.473,131.942c8.018-24.66,20.163-58.882,27.917-69.052,7.123-9.339,20.516-11.142,29.855-4.02,9.34,7.123,11.143,20.516,4.021,29.855-2.777,3.641-12.157,12.683-43.778,32.333-6.383,3.968-12.603,7.698-18.014,10.884ZM375.182,199.875h60.392c9.725,0,17.637,7.912,17.637,17.637v.534h-78.029v-18.171ZM375.182,286.456V234.08h71.235l13.094,52.376h-84.329ZM144.835,457.479c-19.155,0-34.739-15.584-34.739-34.739s15.584-34.739,34.739-34.739c19.155,0,34.739,15.584,34.739,34.739s-15.584,34.739-34.739,34.739ZM427.023,457.479c-19.155,0-34.739-15.584-34.739-34.739s15.584-34.739,34.739-34.739c19.155,0,34.739,15.584,34.739,34.739s-15.584,34.739-34.739,34.739ZM495.967,354.865h-9.086c-5.01,0-9.086-4.076-9.086-9.086v-9.086h18.171v18.171Z"></path>
      <path d="M144.835,406.172c-9.136,0-16.568,7.432-16.568,16.568s7.432,16.568,16.568,16.568c9.136,0,16.568-7.432,16.568-16.568s-7.432-16.568-16.568-16.568Z"></path>
      <path d="M427.023,406.172c-9.136,0-16.568,7.432-16.568,16.568s7.432,16.568,16.568,16.568c9.136,0,16.568-7.432,16.568-16.568s-7.432-16.568-16.568-16.568Z"></path>
      <path d="M332.96,371.967H213.244c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017H332.96c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017Z"></path>
      <path d="M127.733,337.763H25.119c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017Z"></path>
      <path d="M127.733,218.046H93.528c-4.427,0-8.017,3.589-8.017,8.017v68.409c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017v-26.188h17.637c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-17.637V234.08h26.188c4.427,0,8.017-3.589,8.017-8.017,0-4.427-3.589-8.017-8.017-8.017Z"></path>
      <path d="M190.822,272.043c8.023-5.255,13.337-14.317,13.337-24.602,0-16.209-13.186-29.395-29.395-29.395h-21.378c-4.427,0-8.017,3.589-8.017,8.017v68.409c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017v-17.637h13.346l14.722,22.083c1.545,2.317,4.086,3.571,6.677,3.571,1.529,0,3.073-.436,4.439-1.348,3.685-2.455,4.68-7.433,2.223-11.116l-11.987-17.982ZM174.764,260.802h-13.361V234.08h13.361c7.368,0,13.361,5.993,13.361,13.361,0,7.368-5.993,13.361-13.361,13.361Z"></path>
      <path d="M256,286.456h-26.188v-18.198c.177,.012,.354,.027,.534,.027h17.102c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-17.102c-.181,0-.357,.015-.534,.027V234.08H256c4.427,0,8.017-3.589,8.017-8.017,0-4.427-3.589-8.017-8.017-8.017h-34.205c-4.427,0-8.017,3.589-8.017,8.017v68.409c0,4.427,3.589,8.017,8.017,8.017H256c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017Z"></path>
      <path d="M315.858,286.456H289.67v-18.171h9.086c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-9.086V234.08h26.188c4.427,0,8.017-3.589,8.017-8.017,0-4.427-3.589-8.017-8.017-8.017h-34.205c-4.427,0-8.017,3.589-8.017,8.017v68.409c0,4.427,3.589,8.017,8.017,8.017h34.205c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017Z"></path>
    </svg>
  `;
  const PICKUP_STORE_SVG = `
    <svg class="florame-free-shipping-alert__store" viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.75 9.25h14.5l-1.1-4.5H5.85l-1.1 4.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
      <path d="M6.25 9.25v9.5h11.5v-9.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M9.25 18.75v-5.5h5.5v5.5" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
      <path d="M4.75 9.25c.15 1.35 1.25 2.35 2.62 2.35 1.1 0 2.05-.66 2.45-1.6.4.94 1.35 1.6 2.45 1.6s2.05-.66 2.45-1.6c.4.94 1.35 1.6 2.45 1.6 1.37 0 2.47-1 2.62-2.35" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  let resolvedVariantId = Number(config.deliveryVariantId) || null;
  let resolveVariantPromise = null;
  let resolvePricingPromise = null;
  let resolvePricingPromiseKey = '';
  const pricingCacheByPartner = new Map();
  let syncInFlight = false;
  let syncPromise = null;
  let queuedReason = null;
  let scheduleTimer = null;
  let freeShippingAlertTimer = null;
  let lastCartSignature = '';
  let lastMutationAt = 0;
  let lastEnforceAt = 0;
  let cartReadPromise = null;
  let cartReadSnapshot = null;
  let cartReadSnapshotAt = 0;
  let cartReadGeneration = 0;

  function log() {
    if (!config.debug) return;
    console.log('[Florame Delivery Sync]', ...arguments);
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function normalizeHandle(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/^\/+|\/+$/g, '')
      .replace(/^products\//, '')
      .replace(/\.js$/, '')
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-');
  }

  function normalizeHandleList(value) {
    const list = Array.isArray(value) ? value : String(value || '').split(',');
    return list
      .map((entry) => normalizeHandle(entry))
      .filter(Boolean);
  }

  const excludedProductHandles = new Set(normalizeHandleList(config.excludedProductHandles));

  function isCartPage() {
    return /\/cart(?:\/)?$/i.test(window.location.pathname);
  }

  let upsellGuardPromise = null;
  let upsellGuardObserver = null;

  function loadUpsellGuard() {
    if (window.__florameEssentialUpsellGuardLoaded) return Promise.resolve(true);
    if (upsellGuardPromise) return upsellGuardPromise;
    const source = String(config.upsellGuardUrl || '').trim();
    if (!source) return Promise.resolve(false);

    upsellGuardPromise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.dataset.florameUpsellGuard = '1';
      script.addEventListener('load', () => resolve(true), { once: true });
      script.addEventListener('error', () => {
        upsellGuardPromise = null;
        resolve(false);
      }, { once: true });
      document.head.appendChild(script);
    });
    return upsellGuardPromise;
  }

  function observeUpsellSurface() {
    if (!isCartPage() || !document.body || upsellGuardObserver) return;
    const selector = '[data-essential-upsell-element="container"]';
    if (document.querySelector(selector)) {
      loadUpsellGuard();
      return;
    }
    upsellGuardObserver = new MutationObserver(() => {
      if (!document.querySelector(selector)) return;
      upsellGuardObserver.disconnect();
      upsellGuardObserver = null;
      loadUpsellGuard();
    });
    upsellGuardObserver.observe(document.body, { childList: true, subtree: true });
  }

  function isIOSDevice() {
    const ua = window.navigator.userAgent || '';
    return /iPad|iPhone|iPod/.test(ua) || (/Mac/.test(ua) && 'ontouchend' in document);
  }

  function getRegularSubtotalCents(entries) {
    return (entries || []).reduce((sum, entry) => {
      const item = entry && entry.item ? entry.item : {};
      const raw = Number(item.final_line_price || item.line_price || item.original_line_price || 0);
      return sum + (Number.isFinite(raw) ? raw : 0);
    }, 0);
  }

  function normalizeDeliveryType(value) {
    const text = normalizeText(value);
    if (/pickup|ritiro/.test(text)) return 'pickup';
    return 'delivery';
  }

  function isExplicitlyDisabled(value) {
    if (value === false) return true;
    const text = String(value ?? '').trim().toLowerCase();
    return text === 'false' || text === '0' || text === 'off' || text === 'no' || text === 'disabled';
  }

  function getCurrentPartnerRouteContext() {
    try {
      return window.FloramePartner && typeof window.FloramePartner.getContext === 'function'
        ? window.FloramePartner.getContext()
        : null;
    } catch (_) {
      return null;
    }
  }

  function isCurrentPartnerPickupEnabled() {
    const ctx = getCurrentPartnerRouteContext();
    if (!ctx || ctx.active !== true) return false;

    const partner = window.__floramePartner || null;
    if (!partner || typeof partner !== 'object') return false;

    const config = partner.storefrontConfig || {};
    return !isExplicitlyDisabled(config.pickupEnabled ?? partner.pickupEnabled);
  }

  function getCartAttributePartnerSlug(cart) {
    const attrs = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
    return normalizeHandle(attrs.Partner_Source || attrs.Partner_Slug || attrs.Partner_Source_Slug || '');
  }

  function getCurrentPartnerRouteSlug() {
    const ctx = getCurrentPartnerRouteContext();
    if (!ctx || ctx.active !== true) return '';
    return normalizeHandle(ctx.partnerSlug || ctx.slug || ctx.partner || '');
  }

  function getSchedulerDeliveryTypeOverride() {
    if (window.__florameDeliverySchedulerMode) {
      const mode = normalizeDeliveryType(window.__florameDeliverySchedulerMode);
      return mode === 'pickup' && !isCurrentPartnerPickupEnabled() ? 'delivery' : mode;
    }

    if (window.__florameDeliverySchedulerPickupActive === true) {
      return isCurrentPartnerPickupEnabled() ? 'pickup' : 'delivery';
    }

    return '';
  }

  function shouldSyncDeliveryNow() {
    return isCartPage() || getSchedulerDeliveryTypeOverride() === 'pickup';
  }

  function isPickupCart(cart) {
    const cartSlug = getCartAttributePartnerSlug(cart);
    const routeSlug = getCurrentPartnerRouteSlug();
    if (!cartSlug || !routeSlug || cartSlug !== routeSlug || !isCurrentPartnerPickupEnabled()) return false;

    const override = getSchedulerDeliveryTypeOverride();
    if (override) return override === 'pickup';

    const attrs = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
    return normalizeDeliveryType(attrs.Delivery_Type || attrs['Modalita Consegna'] || attrs.Modalita_Consegna) === 'pickup';
  }

  function hasPickupPayload(attrs) {
    if (!attrs || typeof attrs !== 'object') return false;
    return normalizeDeliveryType(attrs.Delivery_Type || attrs['Modalita Consegna'] || attrs.Modalita_Consegna) === 'pickup'
      || !!attrs.Pickup_Address
      || !!attrs.Pickup_Partner
      || !!attrs.Pickup_CAP;
  }

  function clearStalePickupDeliveryAttributes(target) {
    [
      'Data Consegna',
      'Data Consegna (ISO)',
      'Fascia Oraria',
      'Orario Specifico',
      'Destinatario',
      'Indirizzo Consegna',
      'Delivery_Address_V1',
      'Indirizzo_Via',
      'Indirizzo_CAP',
      'Indirizzo_Citta',
      'Indirizzo_Provincia',
      'Telefono',
      'Telefono destinatario',
      'Email destinatario',
      'Recipient_Email',
      'Recipient_Email_Source',
      'Customer_Email',
      'Citofono',
      'Campanello',
      'Note Corriere',
      'Note indirizzo',
      'Messaggio Biglietto',
      'Disegno Biglietto',
      'Biglietto Personalizzato',
      'Modalita biglietto',
      'Ticket_Mode',
      'Font Biglietto',
      'Ticket_Font_ID',
      'Ticket_Renderer_Version',
      'Biglietto Preview URL',
      'Ticket_Preview_URL',
      'Tipo Ordine',
      'Pickup_Address',
      'Pickup_Partner',
      'Pickup_CAP',
      'Delivery_Scheduler_Version',
      'NOTE_ORDINE_RICCA'
    ].forEach((key) => { target[key] = ''; });
    target.Delivery_Type = 'delivery';
    target['Modalita Consegna'] = 'Consegna a domicilio';
  }

  function pickupContextPending(cart) {
    const attrs = cart?.attributes || {};
    if (!hasPickupPayload(attrs) || !getCartAttributePartnerSlug(cart)) return false;
    const context = getCurrentPartnerRouteContext();
    return !context || (context.active === true && !window.__floramePartner);
  }

  async function resetStalePickupCart(cart, reason) {
    if (pickupContextPending(cart)) return cart;
    const attrs = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
    if (!hasPickupPayload(attrs)) return cart;
    const cartSlug = getCartAttributePartnerSlug(cart);
    const routeSlug = getCurrentPartnerRouteSlug();
    const stalePickup = !routeSlug || !cartSlug || cartSlug !== routeSlug || !isCurrentPartnerPickupEnabled();
    if (!stalePickup) return cart;

    const nextAttributes = Object.assign({}, attrs);
    clearStalePickupDeliveryAttributes(nextAttributes);
    try {
      const updated = await postJson(`${root}cart/update.js`, { attributes: nextAttributes });
      try {
        document.dispatchEvent(new CustomEvent('florame:delivery-stale-pickup-reset', {
          detail: { reason: reason || 'delivery-sync', cartSlug, routeSlug }
        }));
      } catch (_) {}
      return updated || cart;
    } catch (error) {
      console.warn('[Florame Delivery Sync] Reset pickup non valido fallito:', error);
      return cart;
    }
  }

  function centsFromAmount(value, fallbackCents) {
    const raw = typeof value === 'string' ? value.replace(',', '.').trim() : value;
    const amount = Number(raw);
    if (!Number.isFinite(amount) || amount < 0) return fallbackCents;
    return Math.round(amount * 100);
  }

  function getApiBase() {
    const themed = window.__florameThemeConfig && window.__florameThemeConfig.apiBase;
    return String(config.apiBase || themed || 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net').replace(/\/+$/, '');
  }

  function getCartPartnerSlug(cart) {
    const attrs = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
    const fromAttr = attrs.Partner_Source || attrs.Partner_Slug || attrs.Partner_Source_Slug || '';
    if (fromAttr) return normalizeHandle(fromAttr);

    const cartItems = Array.isArray(cart?.items) ? cart.items : [];
    const partnerLine = cartItems.find((item) => {
      const properties = item?.properties && typeof item.properties === 'object' ? item.properties : {};
      return properties._florame_partner_slug || properties.Partner_Source || properties.Partner_Slug;
    });
    if (partnerLine) {
      const properties = partnerLine.properties || {};
      return normalizeHandle(
        properties._florame_partner_slug ||
        properties.Partner_Source ||
        properties.Partner_Slug ||
        ''
      );
    }

    try {
      const meta = window.FloramePartner && typeof window.FloramePartner.getAttributionMeta === 'function'
        ? window.FloramePartner.getAttributionMeta()
        : null;
      if (meta && meta.partnerSlug) return normalizeHandle(meta.partnerSlug);
    } catch (_) {}

    const partner = window.__floramePartner || null;
    return normalizeHandle(
      partner?.portal?.partnerSlug ||
      partner?.portal?.tenantSlug ||
      partner?.partnerId ||
      ''
    );
  }

  async function resolvePartnerContext() {
    if (window.__floramePartner && window.__floramePartner.deliveryPricing) return window.__floramePartner;
    try {
      if (window.FloramePartner && typeof window.FloramePartner.resolvePartner === 'function') {
        return await Promise.race([
          window.FloramePartner.resolvePartner(),
          new Promise((resolve) => window.setTimeout(() => resolve(null), 1600)),
        ]);
      }
    } catch (_) {}
    return window.__floramePartner || null;
  }

  function readSessionPricing(partnerSlug, now) {
    if (!partnerSlug || partnerSlug === '_global') return null;
    try {
      const cache = JSON.parse(sessionStorage.getItem(PRICING_SESSION_CACHE_KEY) || '{}');
      const entry = cache && typeof cache === 'object' ? cache[partnerSlug] : null;
      const maxAge = Number(config.pricingCacheMs || 0);
      if (!entry || !Number.isFinite(Number(entry.at)) || now - Number(entry.at) >= maxAge) return null;
      const thresholdCents = Number(entry.value?.thresholdCents);
      if (!Number.isFinite(thresholdCents) || thresholdCents < 0) return null;
      return entry;
    } catch (_) {
      return null;
    }
  }

  function writeSessionPricing(partnerSlugs, pricing, cachedAt) {
    if (!pricing || pricing.source === 'config') return;
    const slugs = Array.from(new Set(
      partnerSlugs
        .map((slug) => normalizeHandle(slug || ''))
        .filter(Boolean)
    ));
    if (!slugs.length) return;
    try {
      const cache = JSON.parse(sessionStorage.getItem(PRICING_SESSION_CACHE_KEY) || '{}');
      const nextCache = cache && typeof cache === 'object' ? cache : {};
      slugs.forEach((slug) => {
        nextCache[slug] = { value: pricing, at: cachedAt };
      });
      sessionStorage.setItem(PRICING_SESSION_CACHE_KEY, JSON.stringify(nextCache));
    } catch (_) {}
  }

  function pricingValue(settings, fallbackCents, extra) {
    const thresholdCents = centsFromAmount(settings?.freeDeliveryThreshold, fallbackCents);
    return {thresholdCents, freeDeliveryMode: settings?.freeDeliveryMode || (thresholdCents === 0 ? 'always' : 'threshold'), deliveryPriceCents: settings?.deliveryProductPrice != null ? centsFromAmount(settings.deliveryProductPrice, 0) : null, variantId: String(settings?.shopifyVariantId || config.deliveryVariantId || ''), ...extra};
  }
  function chargeRequired(pricing, subtotal, pickup, itemCount) {
    if(pickup || !itemCount || pricing.freeDeliveryMode==='always' || pricing.deliveryPriceCents===0)return false;
    return pricing.freeDeliveryMode==='never' || subtotal < Number(pricing.thresholdCents || 0);
  }

  async function resolveDeliveryPricing(cart, {fresh = false} = {}) {
    const fallbackCents = Number(config.thresholdCents || 0) || 3000;
    const now = Date.now();
    const requestedPartnerSlug = getCartPartnerSlug(cart) || '_global';
    const cached = pricingCacheByPartner.get(requestedPartnerSlug);
    if (!fresh && cached && now - cached.at < Number(config.pricingCacheMs || 0)) return cached.value;
    const sessionCached = readSessionPricing(requestedPartnerSlug, now);
    if (!fresh && sessionCached) {
      pricingCacheByPartner.set(requestedPartnerSlug, sessionCached);
      return sessionCached.value;
    }
    if (resolvePricingPromise && resolvePricingPromiseKey === requestedPartnerSlug) {
      if (!fresh) return resolvePricingPromise;
      await resolvePricingPromise;
    }

    resolvePricingPromise = (async () => {
      const partner = await resolvePartnerContext();
      const partnerThreshold = partner?.deliveryPricing?.freeDeliveryThreshold;
      const contextPartnerSlug = normalizeHandle(partner?.portal?.partnerSlug || partner?.partnerSlug || partner?.partnerId || '');
      const contextMatchesCart = requestedPartnerSlug === '_global' || contextPartnerSlug === requestedPartnerSlug;
      if (!fresh && contextMatchesCart && partnerThreshold !== undefined && partnerThreshold !== null && partnerThreshold !== '') {
        return pricingValue(partner.deliveryPricing, fallbackCents, {source:'partner',partnerSlug:normalizeHandle(partner?.portal?.partnerSlug || partner?.partnerId || getCartPartnerSlug(cart))});
      }

      const url = new URL(getApiBase() + '/portalResolveContext');
      url.searchParams.set('host', window.location.host || '');
      const slug = requestedPartnerSlug === '_global' ? '' : requestedPartnerSlug;
      if (slug) url.searchParams.set('partnerSlug', slug);

      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        credentials: 'omit',
        cache: 'no-store',
      }).catch(() => null);
      const data = response && response.ok ? await response.json().catch(() => null) : null;
      if (fresh && !data) throw new Error('Impossibile verificare il costo di consegna. Riprova.');
      const resolvedPartner = data?.partner || null;
      const resolvedThreshold = resolvedPartner?.deliveryPricing?.freeDeliveryThreshold
        ?? data?.deliveryPricingSettings?.freeDeliveryThreshold;
      return pricingValue(resolvedPartner?.deliveryPricing || data?.deliveryPricingSettings, fallbackCents, {source:resolvedPartner?'partner-api':'global-api',partnerSlug:normalizeHandle(resolvedPartner?.portal?.partnerSlug || slug)});
    })()
      .catch((error) => {
        if (fresh) throw error;
        log('pricing fallback', error);
        return { thresholdCents: fallbackCents, source: 'config', partnerSlug: getCartPartnerSlug(cart) };
      })
      .then((pricing) => {
        const cachedAt = Date.now();
        pricingCacheByPartner.set(requestedPartnerSlug, { value: pricing, at: cachedAt });
        const resolvedPartnerSlug = normalizeHandle(pricing?.partnerSlug || '');
        if (resolvedPartnerSlug && resolvedPartnerSlug !== requestedPartnerSlug) {
          pricingCacheByPartner.set(resolvedPartnerSlug, { value: pricing, at: cachedAt });
        }
        writeSessionPricing([requestedPartnerSlug, resolvedPartnerSlug], pricing, cachedAt);
        return pricing;
      })
      .finally(() => {
        resolvePricingPromise = null;
        resolvePricingPromiseKey = '';
      });
    resolvePricingPromiseKey = requestedPartnerSlug;

    return resolvePricingPromise;
  }

  function markNeedsSync() {
    try {
      sessionStorage.setItem(SESSION_FLAG_KEY, '1');
    } catch (error) {
      log('sessionStorage mark failed', error);
    }
  }

  function clearNeedsSync() {
    try {
      sessionStorage.removeItem(SESSION_FLAG_KEY);
    } catch (error) {
      log('sessionStorage clear failed', error);
    }
  }

  function hasPendingSyncFlag() {
    try {
      return sessionStorage.getItem(SESSION_FLAG_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  async function resolveDeliveryVariantId() {
    if (resolvedVariantId) return resolvedVariantId;
    if (resolveVariantPromise) return resolveVariantPromise;

    resolveVariantPromise = (async () => {
      const handle = normalizeHandle(config.deliveryProductHandle);
      if (!handle) return null;

      const response = await fetch(`${root}products/${handle}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`Impossibile caricare /products/${handle}.js`);
      }

      const product = await response.json();
      const variant =
        (product.variants || []).find((candidate) => candidate.available) ||
        (product.variants || [])[0] ||
        null;

      resolvedVariantId = variant ? Number(variant.id) : null;
      return resolvedVariantId;
    })()
      .catch((error) => {
        console.warn('[Florame Delivery Sync] Variant ID Consegna non risolto:', error);
        return null;
      })
      .finally(() => {
        resolveVariantPromise = null;
      });

    return resolveVariantPromise;
  }

  function invalidateCartReadCache() {
    cartReadGeneration += 1;
    cartReadPromise = null;
    cartReadSnapshot = null;
    cartReadSnapshotAt = 0;
  }

  async function getCart(options) {
    const force = options?.force === true;
    const cacheMs = Math.max(0, Number(config.cartReadCacheMs) || 0);
    const now = Date.now();

    if (!force && cartReadPromise) return cartReadPromise;
    if (!force && cartReadSnapshot && now - cartReadSnapshotAt <= cacheMs) {
      return cartReadSnapshot;
    }

    const generation = cartReadGeneration;
    const request = fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(async (response) => {
      if (!response.ok) {
        throw new Error('Impossibile leggere il carrello');
      }

      const cart = await response.json();
      if (generation === cartReadGeneration) {
        cartReadSnapshot = cart;
        cartReadSnapshotAt = Date.now();
      }
      return cart;
    });

    cartReadPromise = request;
    try {
      return await request;
    } finally {
      if (cartReadPromise === request) cartReadPromise = null;
    }
  }

  function isDeliveryItem(item) {
    if (!item) return false;

    if (resolvedVariantId && Number(item.variant_id) === Number(resolvedVariantId)) {
      return true;
    }

    const configuredHandle = normalizeHandle(config.deliveryProductHandle);
    const itemHandle =
      normalizeHandle(item.handle) ||
      normalizeHandle(item.url) ||
      normalizeHandle(item.product_handle);

    if (configuredHandle && itemHandle && itemHandle === configuredHandle) {
      return true;
    }

    const title = normalizeText(item.product_title || item.title);
    if (config.deliveryTitle && title === normalizeText(config.deliveryTitle)) {
      return true;
    }
    if (/^consegna\s+(?:a\s+)?domicilio$/.test(title)) {
      return true;
    }

    if (item.properties && String(item.properties[INTERNAL_PROPERTY_KEY] || '') === '1') {
      return true;
    }

    return false;
  }

  function getItemProductHandle(item) {
    if (!item) return '';
    return normalizeHandle(item.handle)
      || normalizeHandle(item.product_handle)
      || normalizeHandle(item.url)
      || normalizeHandle(item.product_url);
  }

  function isDeliveryExcludedItem(item) {
    const handle = getItemProductHandle(item);
    return !!handle && excludedProductHandles.has(handle);
  }

  function getCartStructure(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const deliveryEntries = [];
    const regularEntries = [];
    const excludedEntries = [];

    items.forEach((item, index) => {
      const entry = { item, line: index + 1 };
      if (isDeliveryItem(item)) {
        deliveryEntries.push(entry);
      } else if (isDeliveryExcludedItem(item)) {
        excludedEntries.push(entry);
      } else {
        regularEntries.push(entry);
      }
    });

    return { items, deliveryEntries, regularEntries, excludedEntries };
  }

  function formatEuroCents(cents) {
    const safeCents = Math.max(0, Math.round(Number(cents) || 0));
    const amount = safeCents / 100;
    const lang = document.documentElement.getAttribute('lang') || navigator.language || 'it-IT';
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: safeCents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: safeCents % 100 === 0 ? 0 : 2,
      }).format(amount);
    } catch (_) {
      return `${amount.toFixed(safeCents % 100 === 0 ? 0 : 2).replace('.', ',')} EUR`;
    }
  }

  function isEnglishStorefront() {
    try {
      if (window.FlorameI18n && typeof window.FlorameI18n.getLanguage === 'function') {
        return window.FlorameI18n.getLanguage() === 'en';
      }
    } catch (_) {}

    const lang = document.documentElement.getAttribute('lang') || navigator.language || '';
    return /^en(?:-|$)/i.test(String(lang));
  }

  function storefrontText(it, en) {
    return isEnglishStorefront() ? en : it;
  }

  function freeShippingAlertTargets() {
    const targets = [];
    const drawerHeader = document.querySelector('cart-drawer .drawer__header');
    const cartPageTitle = document.querySelector('cart-items .title-wrapper-with-link');

    if (drawerHeader) targets.push({ scope: 'drawer', anchor: drawerHeader });
    if (cartPageTitle) targets.push({ scope: 'page', anchor: cartPageTitle });

    return targets;
  }

  function ensureFreeShippingAlert(target) {
    const contextRow = target?.scope === 'page' ? target.anchor.querySelector('.florame-cart-context-row') : null;
    const parent = contextRow || (target && target.anchor ? target.anchor.parentElement : null);
    if (!parent) return null;

    let alert = parent.querySelector(`.florame-free-shipping-alert[data-scope="${target.scope}"]`);
    if (!alert) {
      alert = document.createElement('div');
      alert.className = 'florame-free-shipping-alert';
      alert.dataset.scope = target.scope;
      alert.setAttribute('role', 'status');
      alert.setAttribute('aria-live', 'polite');
    }

    if (contextRow && alert.parentElement !== contextRow) {
      contextRow.appendChild(alert);
    } else if (!contextRow && alert.previousElementSibling !== target.anchor) {
      target.anchor.insertAdjacentElement('afterend', alert);
    }

    return alert;
  }

  function hideFreeShippingAlerts() {
    document.querySelectorAll('.florame-free-shipping-alert').forEach((alert) => {
      alert.hidden = true;
    });
  }

  function renderFreeShippingAlerts(cart, pricing) {
    const targets = freeShippingAlertTargets();
    if (!targets.length) return;

    const { regularEntries } = getCartStructure(cart);
    const thresholdCents = Math.max(0, Number(pricing && pricing.thresholdCents) || 0);
    const regularSubtotalCents = getRegularSubtotalCents(regularEntries);
    const hasRegularItems = regularEntries.length > 0;

    if (!hasRegularItems || (!isPickupCart(cart) && pricing.freeDeliveryMode === 'never' && pricing.deliveryPriceCents !== 0)) {
      hideFreeShippingAlerts();
      return;
    }

    const pickupCart = isPickupCart(cart);

    const achieved = pricing.freeDeliveryMode === 'always' || pricing.deliveryPriceCents === 0 || regularSubtotalCents >= thresholdCents;
    const missingCents = Math.max(0, thresholdCents - regularSubtotalCents);
    const progress = thresholdCents > 0
      ? Math.max(8, Math.min(100, Math.round((regularSubtotalCents / thresholdCents) * 100)))
      : 100;

    targets.forEach((target) => {
      const alert = ensureFreeShippingAlert(target);
      if (!alert) return;

      alert.hidden = false;
      alert.className = `florame-free-shipping-alert ${pickupCart ? 'is-pickup' : (achieved ? 'is-achieved' : 'is-pending')}`;
      alert.dataset.scope = target.scope;
      alert.style.setProperty('--florame-free-shipping-progress', `${pickupCart ? 100 : progress}%`);

      const title = pickupCart
        ? storefrontText('Ritiro in negozio gratuito', 'Free in-store pickup')
        : achieved
        ? storefrontText('Consegna gratuita', 'Free delivery')
        : storefrontText(
          `A ${formatEuroCents(thresholdCents)} sblocchi la spedizione gratuita`,
          `Spend ${formatEuroCents(thresholdCents)} to unlock free delivery`
        );
      const detail = pickupCart
        ? storefrontText('Passa dal tuo fiorista.', 'Collect from your florist.')
        : achieved
        ? storefrontText('Sbloccata per il tuo bouquet', 'Unlocked for your bouquet')
        : storefrontText(
          `Ti mancano ancora ${formatEuroCents(missingCents)}.`,
          `${formatEuroCents(missingCents)} left to go.`
        );

      if (!alert.querySelector('.florame-free-shipping-alert__copy')) alert.innerHTML = `
        <span class="florame-free-shipping-alert__icon" aria-hidden="true">${pickupCart ? PICKUP_STORE_SVG : FREE_SHIPPING_TRUCK_SVG}</span>
        <span class="florame-free-shipping-alert__copy">
          <strong></strong>
          <em></em>
        </span>
        <span class="florame-free-shipping-alert__bar" aria-hidden="true"><i></i></span>
      `;
      const iconKind = pickupCart ? 'pickup' : 'delivery';
      if (alert.dataset.iconKind !== iconKind) {
        alert.querySelector('.florame-free-shipping-alert__icon').innerHTML = pickupCart ? PICKUP_STORE_SVG : FREE_SHIPPING_TRUCK_SVG;
        alert.dataset.iconKind = iconKind;
      }
      const titleNode = alert.querySelector('strong');
      const detailNode = alert.querySelector('em');
      if (titleNode.textContent !== title) titleNode.textContent = title;
      if (detailNode.textContent !== detail) detailNode.textContent = detail;
    });
  }

  async function updateFreeShippingAlerts(reason, cart) {
    try {
      const currentCart = cart || await getCart();
      const pricing = await resolveDeliveryPricing(currentCart);
      renderFreeShippingAlerts(currentCart, pricing);
    } catch (error) {
      log('free shipping alert fallback', reason, error);
      hideFreeShippingAlerts();
    }
  }

  function scheduleFreeShippingAlert(reason, delay) {
    window.clearTimeout(freeShippingAlertTimer);
    freeShippingAlertTimer = window.setTimeout(
      () => updateFreeShippingAlerts(reason),
      typeof delay === 'number' ? delay : 140
    );
  }

  function buildCartSignature(cart) {
    const { items } = getCartStructure(cart);
    return items
      .map((item) => [
        item.key,
        item.variant_id,
        item.quantity,
        isDeliveryItem(item) ? 'D' : (isDeliveryExcludedItem(item) ? 'X' : 'R')
      ].join(':'))
      .join('|');
  }

  async function postJson(url, payload, attempts = 2) {
    let lastError = null;
    for (let attempt = 1; attempt <= attempts; attempt += 1) {
      try {
        window.__florameDeliverySyncActive = true;
        window.__florameDeliverySyncRecent = Date.now();
        lastMutationAt = Date.now();
        invalidateCartReadCache();

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const text = await response.text().catch(() => '');
          throw new Error(`${response.status} ${text}`);
        }

        invalidateCartReadCache();

        return response.json().catch(() => null);
      } catch (error) {
        lastError = error;
        if (attempt < attempts) {
          await new Promise((resolve) => window.setTimeout(resolve, 220 * attempt));
        }
      } finally {
        window.__florameDeliverySyncActive = false;
        window.__florameDeliverySyncRecent = Date.now();
      }
    }

    throw lastError;
  }

  async function waitForCartIdle(maxMs = 2200) {
    const start = Date.now();

    while (Date.now() - start < maxMs) {
      const disabled = document.querySelector('.cart__items--disabled');
      if (!disabled) return;
      await new Promise((resolve) => window.setTimeout(resolve, 80));
    }
  }

  function dispatchCartRefresh(meta) {
    const passes = Array.isArray(meta && meta.passes) && meta.passes.length
      ? meta.passes
      : isIOSDevice()
      ? config.iosRefreshPasses
      : config.defaultRefreshPasses;

    document.dispatchEvent(
      new CustomEvent('florame:delivery-cart-refresh', {
        detail: Object.assign(
          {
            at: Date.now(),
            passes,
            cacheBust: true,
          },
          meta || {}
        ),
      })
    );
  }

  function assertDeliveryState(cart, pricing) {
    const { deliveryEntries, regularEntries } = getCartStructure(cart);
    const pickupCart = isPickupCart(cart);
    const regularSubtotalCents = getRegularSubtotalCents(regularEntries);
    const shouldChargeDelivery = chargeRequired(pricing,regularSubtotalCents,pickupCart,regularEntries.length);
    const deliveryQuantity = deliveryEntries.reduce(
      (sum, entry) => sum + Number(entry?.item?.quantity || 0),
      0
    );

    if (shouldChargeDelivery && (deliveryQuantity !== 1 || deliveryEntries.some(entry => String(entry.item.variant_id) !== String(pricing.variantId || resolvedVariantId)))) {
      throw new Error('Costo di consegna non sincronizzato. Riprova prima di autorizzare l’ordine.');
    }
    if (!shouldChargeDelivery && deliveryQuantity !== 0) {
      throw new Error('La modalità scelta non coincide con il costo di consegna nel carrello.');
    }
    return cart;
  }

  async function enforceDeliveryState(reason) {
    await resolveDeliveryVariantId();

    let firstCart = await getCart();
    firstCart = await resetStalePickupCart(firstCart, reason);
    const firstSignature = buildCartSignature(firstCart);
    const { deliveryEntries, regularEntries } = getCartStructure(firstCart);
    const pricing = await resolveDeliveryPricing(firstCart, {fresh:true});
    resolvedVariantId = Number(pricing.variantId) || null;
    if(resolvedVariantId)window.florameDeliveryConfig = Object.assign({},window.florameDeliveryConfig,{deliveryVariantId:resolvedVariantId});
    if(deliveryEntries.some(entry=>String(entry.item.variant_id)!==String(resolvedVariantId))){
      for(const entry of [...deliveryEntries].sort((a,b)=>b.line-a.line))await postJson(`${root}cart/change.js`,{line:entry.line,quantity:0});
      return enforceDeliveryState(reason);
    }
    const regularSubtotalCents = getRegularSubtotalCents(regularEntries);
    renderFreeShippingAlerts(firstCart, pricing);
    const pickupCart = isPickupCart(firstCart);
    const shouldChargeDelivery = chargeRequired(pricing,regularSubtotalCents,pickupCart,regularEntries.length);

    let changed = false;

    if (!shouldChargeDelivery) {
      if (deliveryEntries.length > 0) {
        for (const entry of [...deliveryEntries].sort((a, b) => b.line - a.line)) {
          await postJson(`${root}cart/change.js`, { line: entry.line, quantity: 0 });
          changed = true;
        }
      }
    } else if (deliveryEntries.length === 0) {
      if (!resolvedVariantId) {
        throw new Error('Costo di consegna non disponibile. Il pagamento resta bloccato.');
      } else {
        await postJson(`${root}cart/add.js`, {
          items: [
            {
              id: Number(resolvedVariantId),
              quantity: 1,
              properties: {
                [INTERNAL_PROPERTY_KEY]: '1',
              },
            },
          ],
        });
        changed = true;
      }
    } else {
      const [keeper, ...extras] = deliveryEntries;

      if (Number(keeper.item.quantity || 0) !== 1) {
        await postJson(`${root}cart/change.js`, {
          line: keeper.line,
          quantity: 1,
        });
        changed = true;
      }

      for (const extra of [...extras].sort((a, b) => b.line - a.line)) {
        await postJson(`${root}cart/change.js`, {
          line: extra.line,
          quantity: 0,
        });
        changed = true;
      }
    }

    if (changed) {
      clearNeedsSync();
      await waitForCartIdle();
      dispatchCartRefresh({ reason, mode: 'delivery-synced' });
      await new Promise((resolve) => window.setTimeout(resolve, 220));
      const verifyCart = await getCart();
      renderFreeShippingAlerts(verifyCart, pricing);
      assertDeliveryState(verifyCart, pricing);
      lastCartSignature = buildCartSignature(verifyCart);
      return { changed: true, cart: verifyCart };
    }

    if (isCartPage() && deliveryEntries.length === 1 && regularEntries.length > 0 && !chargeRequired(pricing, regularSubtotalCents, pickupCart, regularEntries.length)) {
      dispatchCartRefresh({
        reason,
        mode: 'free-delivery-refresh',
      });
    }

    lastCartSignature = firstSignature;
    clearNeedsSync();
    assertDeliveryState(firstCart, pricing);
    return { changed: false, cart: firstCart };
  }

  async function syncDelivery(reason, options) {
    const strict = options?.strict === true;
    const verifyOnly = options?.verifyOnly === true;
    const providedCart = options?.cart && typeof options.cart === 'object'
      ? options.cart
      : null;
    if (syncPromise) {
      queuedReason = reason || 'queued';
      try {
        return await syncPromise;
      } catch (error) {
        if (strict) throw error;
        return null;
      }
    }

    syncInFlight = true;
    syncPromise = (async () => {
      const cart = providedCart || await getCart();
      if (pickupContextPending(cart)) {
        if (strict) throw new Error('Stiamo verificando il ritiro con il fiorista. Riprova tra pochi secondi.');
        return { changed: false, pending: true, cart };
      }
      const signature = buildCartSignature(cart);
      const { deliveryEntries, regularEntries } = getCartStructure(cart);
      const pickupCart = isPickupCart(cart);
      const needsSync = pickupCart
        ? deliveryEntries.length > 0
        : (
          hasPendingSyncFlag() || regularEntries.length === 0
            ? deliveryEntries.length > 0
            : deliveryEntries.length !== 1 || Number((deliveryEntries[0] && deliveryEntries[0].item.quantity) || 0) !== 1
        );

      // La verifica finale possiede gia il carrello fresco restituito da
      // /cart/update.js. Se il costo consegna e coerente, validalo in-place:
      // niente secondo /cart.js, refresh del tema o mutazione ridondante.
      if (verifyOnly && !needsSync) {
        const pricing = await resolveDeliveryPricing(cart, {fresh:true});
        try { assertDeliveryState(cart, pricing); } catch (_) { return enforceDeliveryState(reason); }
        renderFreeShippingAlerts(cart, pricing);
        lastCartSignature = signature;
        lastEnforceAt = Date.now();
        clearNeedsSync();
        return { changed: false, cart };
      }

      if (!strict && !needsSync && signature === lastCartSignature && Date.now() - lastMutationAt > 400 && Date.now() - lastEnforceAt < 3000) {
        const pricing = await resolveDeliveryPricing(cart);
        assertDeliveryState(cart, pricing);
        return { changed: false, cart };
      }

      lastEnforceAt = Date.now();
      return enforceDeliveryState(reason);
    })();

    try {
      return await syncPromise;
    } catch (error) {
      console.error('[Florame Delivery Sync] Errore sync:', error);
      if (strict) throw error;
      return null;
    } finally {
      syncInFlight = false;
      syncPromise = null;
      if (queuedReason) {
        const nextReason = queuedReason;
        queuedReason = null;
        window.setTimeout(() => syncDelivery(nextReason), 180);
      }
    }
  }

  function scheduleSync(reason, delay) {
    if (!config.enabled) return;
    window.clearTimeout(scheduleTimer);
    scheduleTimer = window.setTimeout(() => syncDelivery(reason), typeof delay === 'number' ? delay : 120);
  }

  function patchFetchForProductAdds() {
    const originalFetch = window.fetch ? window.fetch.bind(window) : null;
    if (!originalFetch) return;

    window.fetch = async function florameDeliveryPatchedFetch(input, init) {
      const requestUrl = typeof input === 'string' ? input : input && input.url ? input.url : '';
      const cartMutation = /\/cart\/(?:add|change|update)(?:\.js)?(?:\?|$)/i.test(requestUrl);
      if (cartMutation) invalidateCartReadCache();
      const response = await originalFetch(input, init);

      if (cartMutation && response && response.ok) invalidateCartReadCache();

      if (/\/cart\/add(?:\.js)?(?:\?|$)/i.test(requestUrl) && response && response.ok) {
        markNeedsSync();
        scheduleFreeShippingAlert(`fetch:${requestUrl}`, 160);
        if (shouldSyncDeliveryNow()) {
          scheduleSync(`fetch:${requestUrl}`, 120);
        }
      } else if (/\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/i.test(requestUrl) && response && response.ok) {
        scheduleFreeShippingAlert(`fetch:${requestUrl}`, 160);
        if (shouldSyncDeliveryNow()) {
          scheduleSync(`fetch:${requestUrl}`, 120);
        }
      }

      return response;
    };
  }

  function patchXHRForProductAdds() {
    if (!window.XMLHttpRequest) return;

    const OriginalOpen = XMLHttpRequest.prototype.open;
    const OriginalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function florameOpen(method, url) {
      this.__florameCartUrl = url;
      return OriginalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function florameSend() {
      const requestUrl = String(this.__florameCartUrl || '');
      if (/\/cart\/(?:add|change|update)(?:\.js)?(?:\?|$)/i.test(requestUrl)) {
        invalidateCartReadCache();
      }
      this.addEventListener('load', () => {
        const url = String(this.__florameCartUrl || '');
        if (/\/cart\/(?:add|change|update)(?:\.js)?(?:\?|$)/i.test(url) && this.status >= 200 && this.status < 300) {
          invalidateCartReadCache();
        }
        if (/\/cart\/add(?:\.js)?(?:\?|$)/i.test(url) && this.status >= 200 && this.status < 300) {
          markNeedsSync();
          scheduleFreeShippingAlert(`xhr:${url}`, 160);
          if (shouldSyncDeliveryNow()) {
            scheduleSync(`xhr:${url}`, 120);
          }
        } else if (/\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/i.test(url) && this.status >= 200 && this.status < 300) {
          scheduleFreeShippingAlert(`xhr:${url}`, 160);
          if (shouldSyncDeliveryNow()) {
            scheduleSync(`xhr:${url}`, 120);
          }
        }
      });

      return OriginalSend.apply(this, arguments);
    };
  }

  document.addEventListener(
    'submit',
    function onProductFormSubmit(event) {
      const form = event.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      const action = String(form.getAttribute('action') || '');
      if (/\/cart\/add(?:\.js)?$/i.test(action)) {
        markNeedsSync();
      }
    },
    true
  );

  document.addEventListener('florame:cart-updated', () => {
    scheduleFreeShippingAlert('cart-updated', 120);
    if (!shouldSyncDeliveryNow()) return;
    scheduleSync('cart-updated', 90);
  });

  document.addEventListener('florame:delivery-cart-refresh', () => {
    scheduleFreeShippingAlert('delivery-cart-refresh', 220);
    if (!shouldSyncDeliveryNow()) return;
    lastCartSignature = '';
  });

  document.addEventListener('florame:partner-ready', () => {
    lastCartSignature = '';
    scheduleFreeShippingAlert('partner-ready', 30);
    if (shouldSyncDeliveryNow()) {
      scheduleSync('partner-ready', 80);
    }
  });

  document.addEventListener('florame:delivery-mode-changed', (event) => {
    const deliveryType = normalizeDeliveryType(event?.detail?.deliveryType || '');
    lastCartSignature = '';
    scheduleFreeShippingAlert(`delivery-mode:${deliveryType || 'unknown'}`, 20);
    if (deliveryType === 'pickup' || shouldSyncDeliveryNow()) {
      scheduleSync(`delivery-mode:${deliveryType || 'unknown'}`, 20);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    patchFetchForProductAdds();
    patchXHRForProductAdds();
    observeUpsellSurface();

    if (shouldSyncDeliveryNow()) {
      scheduleSync(hasPendingSyncFlag() ? 'dom-ready-pending' : 'dom-ready', hasPendingSyncFlag() ? 20 : 60);
    }
    scheduleFreeShippingAlert('dom-ready', 120);
  });

  window.addEventListener('pageshow', () => {
    observeUpsellSurface();
    scheduleFreeShippingAlert('pageshow', 140);
    if (shouldSyncDeliveryNow()) {
      scheduleSync(hasPendingSyncFlag() ? 'pageshow-pending' : 'pageshow', hasPendingSyncFlag() ? 20 : 80);
    }
  });

  window.addEventListener('focus', () => {
    scheduleFreeShippingAlert('focus', 180);
    if (shouldSyncDeliveryNow()) {
      scheduleSync('focus', 120);
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      scheduleFreeShippingAlert('visible', 180);
      if (shouldSyncDeliveryNow()) {
        scheduleSync('visible', 120);
      }
    }
  });

  window.florameEnsureDeliveryLine = function florameEnsureDeliveryLine(options) {
    if (options?.verifyOnly !== true) markNeedsSync();
    return syncDelivery(options?.reason || 'manual-call', {
      strict: options?.strict !== false,
      verifyOnly: options?.verifyOnly === true,
      cart: options?.cart || null,
    });
  };
})();
